<script lang="ts">
  import { Image } from '@unpic/svelte/base'
  import type { UrlTransformerOptions } from 'unpic'
  import { storybookImages } from '$lib/storybook-images'
  export let src: string

  type $$Props = Image['$$prop_def'] & { imgClass?: string }
  const { class: containerClass, imgClass, ...typedProps } = $$props as $$Props & { imgClass?: string }
  const loading = typedProps.loading ?? 'lazy'
  const fetchpriority = typedProps.fetchpriority ?? (typedProps.priority ? 'high' : 'low')

  const isButaneDomain = typeof window !== 'undefined' && window.location.hostname.endsWith('butane.dev')
  const base =
    import.meta.env.VITE_BRANDING_IMAGE_BASE_URL ?? (isButaneDomain ? 'https://butane.dev/images' : '/app/images')
  const normalizedSrc = src.replace(/^\//, '')
  const storybookSrc = storybookImages[`/src/lib/assets/branding/${normalizedSrc}`]
  const resolvedSrc = import.meta.env.STORYBOOK && storybookSrc ? storybookSrc : `${base}/${normalizedSrc}`

  const makeTransformer =
    (src: string) =>
    (_url: string | URL, { width }: UrlTransformerOptions) => {
      if (import.meta.env.STORYBOOK && storybookSrc) return storybookSrc

      const path = src.replace(/^\//, '').split('/').map(encodeURIComponent).join('/')
      return `${base}/${path}${width ? `?width=${width}` : ''}`
    }
</script>

<div class={containerClass}>
  <Image
    {...typedProps}
    {loading}
    {fetchpriority}
    class={imgClass}
    src={resolvedSrc}
    breakpoints={[320, 480, 768, 1024, 1280, 1440, 1920]}
    transformer={makeTransformer(src)}
  />
</div>
